import React from "react"
import Link from "gatsby-link"
import styled from "styled-components"
import { Subhead, Heading, Flex, Box, Text } from "rebass"
//TODO: Use better import for smaller bundle
import * as faIcons from "@fortawesome/fontawesome-free-solid"

import FullPageVideo from "../components/FullPageVideo"
import BigSlider from "../components/BigSlider"
import FadeInFeature from "../components/FadeInFeature"
import MaxWidth from "../components/MaxWidth"
import TwoOneBox from "../components/TwoOneBox"
import FeatureSlider from "../components/FeatureSlider"

import colors from "../config/colors.js"

const StyledHeading = styled(Heading)`
  text-align: center;
  text-shadow: 0 0 5px rgba(0, 0, 0, 1);
  color: white;
`
const MainHeader = styled(StyledHeading)`
`

const SubHeader = styled(StyledHeading)`
`

MainHeader.defaultProps = {
  fontSize: ["6.3rem", "7.5rem", "7.5rem", "7.5rem"],
}

SubHeader.defaultProps = {
  fontSize: "2.5rem",
}

const IndexPage = ({ data }) => {
  const { homePage: { text } } = data

  return (
    <Flex flexDirection="column">
      <FullPageVideo
        video={`http://www.ykwc.com/images/${text.backgroundVideo}`}
      >
        <Flex
          flex="1"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
        >
          <MainHeader>{text.bannerHeading}</MainHeader>
          <SubHeader>{text.bannerSubheading}</SubHeader>
        </Flex>
      </FullPageVideo>
      <Flex bg={colors.secondaryDark} color={"white"}>
        <MaxWidth py={5} justifyContent="space-around" flexWrap="wrap">
          <Box width={[1, 1 / 2, 1 / 2, 1 / 4]} mt={4}>
            <FadeInFeature
              iconColor={colors.yellow}
              iconBg={colors.black}
              borderColor={colors.gray}
              hoverColor={colors.gray}
              icon={faIcons[text.iconName1]}
              heading={text.iconHeading1}
              subheading={text.iconSubheading1}
            />
          </Box>
          <Box width={[1, 1 / 2, 1 / 2, 1 / 4]} mt={4}>
            <FadeInFeature
              iconColor={colors.yellow}
              iconBg={colors.black}
              borderColor={colors.gray}
              hoverColor={colors.gray}
              icon={faIcons[text.iconName2]}
              heading={text.iconHeading2}
              subheading={text.iconSubheading2}
            />
          </Box>
          <Box width={[1, 1 / 2, 1 / 2, 1 / 4]} mt={4}>
            <FadeInFeature
              iconColor={colors.yellow}
              iconBg={colors.black}
              borderColor={colors.gray}
              hoverColor={colors.gray}
              icon={faIcons[text.iconName3]}
              heading={text.iconHeading3}
              subheading={text.iconSubheading3}
            />
          </Box>
          <Box width={[1, 1 / 2, 1 / 2, 1 / 4]} mt={4}>
            <FadeInFeature
              iconColor={colors.yellow}
              iconBg={colors.black}
              borderColor={colors.gray}
              hoverColor={colors.gray}
              icon={faIcons[text.iconName4]}
              heading={text.iconHeading4}
              subheading={text.iconSubheading4}
            />
          </Box>
        </MaxWidth>
      </Flex>
      <Flex pt={5} bg={colors.gray}>
        <MaxWidth>
          <FeatureSlider
            bg={colors.gray}
            color={colors.grayText}
            headingColor="black"
            quotes={text.quotes}
          />
        </MaxWidth>
      </Flex>
    </Flex>
  )
}

export default IndexPage

export const query = graphql`
  query HomePageQuery {
    homePage {
      text {
        quotes {
          author
          body
        }
        iconName1
        iconName2
        iconName3
        iconName4
        iconHeading1
        iconHeading2
        iconHeading3
        iconHeading4
        bannerHeading
        backgroundVideo
        iconSubheading1
        iconSubheading2
        iconSubheading3
        iconSubheading4
        bannerSubheading
      }
    }
  }
  `



// WEBPACK FOOTER //
// ./src/pages/index.js